module.exports = __webpack_public_path__ + "media/images/emblems/Blason_ville_ch_Ormont-Dessus_(Vaud)-bcabf50ef2fd32e52304fa7294d5d47d.svg";